(() => {
  "use strict";

  const SEL = {
    price: ".crossbundle-price-container",
    info: ".Product__Info",
    priceMainRow: ".crossbundle-price__main-row",
    filterTabs: ".crossbundle-drawer-filter-tabs",
    notification: ".crossbundle-intent__last-selected",
  };

  let infoObserver = null;
  let priceSavingsObservedEl = null;
  let priceSavingsObserver = null;
  let priceSavingsAttachTimer = null;
  let priceSavingsLookupAttempts = 0;

  let notificationObserver = null;
  let notificationTick = false;

  /** Deutscher Shop-Preis (z. B. "175,60 €", "1.234,56 €") → Zahl. */
  function parseEuroDe(text) {
    if (!text) return 0;
    const raw = text
      .replace(/ /g, "")
      .replace(/\s/g, "")
      .replace("€", "")
      .trim();
    const match = raw.match(
      /(\d{1,3}(?:\.\d{3})*(?:,\d{1,2})?|\d+,\d{1,2}|\d+)/
    );
    if (!match) return 0;
    let s = match[1];
    if (s.indexOf(",") !== -1) {
      s = s.replace(/\./g, "").replace(",", ".");
    } else {
      s = s.replace(/\./g, "");
    }
    const v = parseFloat(s);
    return Number.isFinite(v) ? v : 0;
  }

  /** Zusatzzeile unter der Preiszeile: „Du sparst …€!“ (Prozent-Badge bleibt von der App). */
  function updateCrossbundleSavingsLine() {
    document.querySelectorAll(SEL.priceMainRow).forEach(function (row) {
      const content = row.closest(".crossbundle-price__content");
      if (!content) return;

      const compareEl = row.querySelector(".crossbundle-price__compare");
      const priceEl = row.querySelector(".crossbundle-price__price");
      if (!compareEl || !priceEl) {
        const orphan = content.querySelector(".crossbundle-price__savings-note");
        if (orphan) orphan.remove();
        return;
      }

      let note = content.querySelector(".crossbundle-price__savings-note");

      const compareVal = parseEuroDe(compareEl.textContent);
      const priceVal = parseEuroDe(priceEl.textContent);

      if (!(compareVal > priceVal && compareVal > 0)) {
        if (note) note.remove();
        return;
      }

      const saved = compareVal - priceVal;
      if (!(saved > 0)) {
        if (note) note.remove();
        return;
      }

      const amountStr =
        new Intl.NumberFormat("de-DE", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(saved) +
        "€!";

      const text = "Du sparst " + amountStr;

      if (!note) {
        note = document.createElement("p");
        note.className = "crossbundle-price__savings-note";
        row.insertAdjacentElement("afterend", note);
      }

      if (note.textContent !== text) {
        note.textContent = text;
      }
    });
  }

  const MAX_PRICE_SAVINGS_LOOKUP = 200;

  function detachCrossbundlePriceSavingsObserver() {
    if (priceSavingsAttachTimer) {
      window.clearTimeout(priceSavingsAttachTimer);
      priceSavingsAttachTimer = null;
    }
    if (priceSavingsObserver) {
      priceSavingsObserver.disconnect();
      priceSavingsObserver = null;
    }
    priceSavingsObservedEl = null;
  }

  /**
   * Beobachtet den App-Preisblock: sobald Vergleichs-/Aktionspreis im DOM steht oder sich ändert,
   * wird die „Du sparst“-Zeile gesetzt (ohne schweren document.body-Observer).
   */
  function attachCrossbundlePriceSavingsObserver() {
    const container = document.querySelector(SEL.price);
    if (!container) {
      if (priceSavingsLookupAttempts >= MAX_PRICE_SAVINGS_LOOKUP) return;
      priceSavingsLookupAttempts += 1;
      if (priceSavingsAttachTimer) window.clearTimeout(priceSavingsAttachTimer);
      priceSavingsAttachTimer = window.setTimeout(function () {
        priceSavingsAttachTimer = null;
        attachCrossbundlePriceSavingsObserver();
      }, 250);
      return;
    }

    priceSavingsLookupAttempts = 0;

    if (priceSavingsObservedEl === container && priceSavingsObserver) {
      updateCrossbundleSavingsLine();
      return;
    }

    if (priceSavingsObserver) {
      try {
        priceSavingsObserver.disconnect();
      } catch (e) {
        /* ignore */
      }
      priceSavingsObserver = null;
    }

    priceSavingsObservedEl = container;

    let savingsTick = false;
    priceSavingsObserver = new MutationObserver(function () {
      if (savingsTick) return;
      savingsTick = true;
      requestAnimationFrame(function () {
        savingsTick = false;
        updateCrossbundleSavingsLine();
      });
    });

    priceSavingsObserver.observe(container, {
      childList: true,
      subtree: true,
      characterData: true,
      characterDataOldValue: false,
    });

    updateCrossbundleSavingsLine();
  }

  function scheduleSavingsLineRetries() {
    [0, 150, 400, 900, 1600, 2800, 4500, 7000, 11000, 17000, 25000, 40000].forEach(
      function (ms) {
        window.setTimeout(function () {
          if (ms === 25000 || ms === 40000) {
            priceSavingsLookupAttempts = 0;
          }
          attachCrossbundlePriceSavingsObserver();
          updateCrossbundleSavingsLine();
        }, ms);
      }
    );
  }

  /**
   * Übersetzt die CrossBundle-Notification „{Produkt} added successfully!“ → deutsch.
   * Regex greift den Produktnamen generisch; nach der Übersetzung matcht das Muster
   * nicht mehr → kein Re-Trigger, keine Endlosschleife.
   */
  function translateCrossbundleNotification() {
    document.querySelectorAll(SEL.notification).forEach(function (el) {
      const match = el.textContent.match(/^\s*(.+?)\s+added successfully!\s*$/i);
      if (match) {
        const text = match[1] + " wurde erfolgreich hinzugefügt!";
        if (el.textContent !== text) el.textContent = text;
      }
    });
  }

  /**
   * Beobachtet das komplette DOM auf die Notification (wird ohne Page-Load per JS
   * eingefügt/geändert, sobald ein Produkt gewählt wird). rAF-Throttle bündelt die
   * Übersetzung pro Frame statt bei jeder Mutation.
   */
  function watchCrossbundleNotifications() {
    translateCrossbundleNotification();

    if (notificationObserver) return;

    notificationObserver = new MutationObserver(function () {
      if (notificationTick) return;
      notificationTick = true;
      requestAnimationFrame(function () {
        notificationTick = false;
        translateCrossbundleNotification();
      });
    });

    notificationObserver.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  /** Absatz über den Filter-Tabs im CrossBundle-Drawer (App rendert Tabs ohne Überschrift). */
  function ensureCrossbundleFilterHint() {
    document.querySelectorAll(SEL.filterTabs).forEach(function (tabs) {
      const prev = tabs.previousElementSibling;
      if (prev && prev.classList.contains("crossbundle-drawer-filter-hint")) {
        if (prev.textContent !== "Filtere hier nach Bedürfnis:") {
          prev.textContent = "Filtere hier nach Bedürfnis:";
        }
        return;
      }
      const p = document.createElement("p");
      p.className = "crossbundle-drawer-filter-hint";
      p.textContent = "Filtere hier nach Bedürfnis:";
      const parent = tabs.parentNode;
      if (!parent) return;
      parent.insertBefore(p, tabs);
    });
  }

  function applyCrossbundleDrawerEnhancements() {
    ensureCrossbundleFilterHint();
  }

  function scheduleRetries() {
    [0, 200, 600, 1200, 2500].forEach(function (ms) {
      window.setTimeout(function () {
        updateCrossbundleSavingsLine();
        applyCrossbundleDrawerEnhancements();
        attachCrossbundlePriceSavingsObserver();
      }, ms);
    });
  }

  function scheduleFilterHintRetries() {
    [400, 1200, 2800, 6000, 12000].forEach(function (ms) {
      window.setTimeout(applyCrossbundleDrawerEnhancements, ms);
    });
  }

  function attachLimitedObserver() {
    if (infoObserver) {
      infoObserver.disconnect();
      infoObserver = null;
    }

    const root = document.querySelector(SEL.info);
    if (!root) return;

    let runs = 0;
    const maxRuns = 60;
    let rafPending = false;

    infoObserver = new MutationObserver(function () {
      if (rafPending || runs >= maxRuns) return;
      rafPending = true;
      requestAnimationFrame(function () {
        rafPending = false;
        runs += 1;
        updateCrossbundleSavingsLine();
        applyCrossbundleDrawerEnhancements();
        attachCrossbundlePriceSavingsObserver();
      });
    });

    infoObserver.observe(root, { childList: true, subtree: true });

    window.setTimeout(function () {
      if (infoObserver) {
        infoObserver.disconnect();
        infoObserver = null;
      }
    }, 12000);
  }

  function init() {
    updateCrossbundleSavingsLine();
    applyCrossbundleDrawerEnhancements();
    attachCrossbundlePriceSavingsObserver();
    scheduleSavingsLineRetries();
    scheduleRetries();
    scheduleFilterHintRetries();
    attachLimitedObserver();
    watchCrossbundleNotifications();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window.addEventListener("load", function () {
    updateCrossbundleSavingsLine();
    applyCrossbundleDrawerEnhancements();
    attachCrossbundlePriceSavingsObserver();
    watchCrossbundleNotifications();
  });

  document.addEventListener("shopify:section:load", function () {
    detachCrossbundlePriceSavingsObserver();
    priceSavingsLookupAttempts = 0;
    scheduleRetries();
    scheduleFilterHintRetries();
    scheduleSavingsLineRetries();
    attachLimitedObserver();
    updateCrossbundleSavingsLine();
    applyCrossbundleDrawerEnhancements();
    attachCrossbundlePriceSavingsObserver();
    watchCrossbundleNotifications();
  });

  document.addEventListener(
    "click",
    function (e) {
      if (e.target.closest(".crossbundle-offer-box")) {
        window.setTimeout(updateCrossbundleSavingsLine, 350);
        window.setTimeout(updateCrossbundleSavingsLine, 900);
      }
      if (e.target.closest("[class*='crossbundle']")) {
        window.setTimeout(applyCrossbundleDrawerEnhancements, 250);
        window.setTimeout(applyCrossbundleDrawerEnhancements, 800);
        window.setTimeout(attachCrossbundlePriceSavingsObserver, 300);
        window.setTimeout(updateCrossbundleSavingsLine, 500);
        window.setTimeout(updateCrossbundleSavingsLine, 1200);
      }
    },
    true
  );
})();